<template>
    <div class="w-full h-screen flex flex-col items-center justify-between">
        <div v-if="loading" class="flex flex-col w-full overflow-y-auto justify-center items-center">
            <img src="../assets/loading.gif" class="w-full h-auto" />
        </div>
        <div v-else class="flex flex-wrap w-full overflow-y-auto">
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-center sticky top-0">
                <div>Select {{levels[currentLevel].toUpperCase()}}</div>
            </div>
            <div class="w-full h- py-2 pl-2 border-b border-gray-200 flex flex-wrap">
                <div v-for="item in items" :key="item" class="w-1/4 pr-2 pb-2"><div @click="select(item)" class="font-bold text-indigo-600 w-full py-4 bg-gray-100 flex flex-row items-center justify-center rounded border-2 border-gray-400">{{item}}</div></div>
            </div>
        </div>
        <div class="py-2 border-t border-gray-200 bg-white w-full text-center">
            <button @click="back" class="bg-gray-200 mb-2 p-2 px-16 text-indigo-700 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>

</template>

<script>
    import axios from "axios";
    import {getSlots, setSlots} from "../library/session";
    import {uniq, map, sortBy} from "lodash";

    export default {
        name: "Slot",
        components : {

        },
        data: function() {
            return {
                levels: ['area', 'zone', 'aisle', 'side', 'col', 'level', 'position'],
                currentLevel: -1,
                items: [],
                slot: {
                    area: null,
                    zone: null,
                    aisle: null,
                    side: null,
                    col: null,
                    level: null,
                    position: null
                },
                slots: [],
                loading: true,
                qrCode: ''
            }
        },
        methods: {
            back() {
                this.$emit("back")
            },
            nextLevel() {
                this.currentLevel++;
                if(this.currentLevel>6) {
                    this.$emit('slot', this.slot);
                    return;
                }
                let goOn=true;
                while(goOn) {
                    let items = uniq(map(this.slots, slot => slot[this.levels[this.currentLevel]]));
                    if (items.length === 1 && items[0] === null) {
                        this.currentLevel++;
                        if(this.currentLevel>6) {
                            this.$emit('slot', this.slot);
                            return;
                        }
                    } else {
                        this.items = sortBy(items, item => item);
                        goOn=false;
                    }
                }
            },
            signalLoaded() {
                this.nextLevel();
                this.loading = false;
            },
            select(item) {
                this.slot[this.levels[this.currentLevel]] = item;
                this.nextLevel();
            }
        },
        created() {
            const url = "/manager/transport/sync/slots/";
            let slots = getSlots()
            if(slots!==null) {
                this.slots = slots;
                this.signalLoaded()
            } else {
                axios.get(url).then(response => {
                    this.slots = response.data.slots;
                    setSlots(this.slots);
                    this.signalLoaded()
                });
            }
        }
    }
</script>

<style scoped>

</style>